
import axios from 'axios';
import { defineComponent } from 'vue';
import HelloWorld from '@/components/HelloWorld.vue'; // @ is an alias to /src
import PublicationsTable from '@/components/PublicationsTable.vue';

export default defineComponent({
  name: 'PublicationsView',
  components: {
    PublicationsTable
  },
  data() {
    return {
      items: [] as Array<any>,
      options: { params: { page: 1, s: '', sortColumn: 'year', sortOrder: 'desc' } },
      isLoading: false,
      showLoadMoreBtn: false,
      searchTimeout: 0,
      componentKey: 0
    }
  },
  created() {
    this.fetchTableData(false);
  },
  methods: {
    fetchTableData(emptyData: boolean)
    {
      this.isLoading = true;

      axios.get('/wp-json/arbor/v1/publications/entries', this.options)
      .then(response => {

        this.isLoading = false;
        this.componentKey += 1;

        if(emptyData || this.items.length == 0) {
          this.items = response.data.entries;
        } else {
          for (var i = 0; i < response.data.entries.length; i++) {
            this.items.push(response.data.entries[i]);
          }
        }

        this.showLoadMoreBtn = response.data.showLoadMore;
      })
      .catch(error =>{
        console.log(error);
      })
    },
    onClickLoadBtn()
    {
      this.options.params.page += 1;
      this.fetchTableData(false);
    },
    onSearchInput()
    {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }

      this.searchTimeout = setTimeout(() => {
          this.showLoadMoreBtn = false;
          this.options.params.page = 1;
          this.fetchTableData(true);
          this.searchTimeout = 0;
      }, 400);
    },
    onTableSortChange(column: string, order: string)
    {
      this.options.params.sortColumn = column;
      this.options.params.sortOrder = order;

      this.showLoadMoreBtn = false;
      this.options.params.page = 1;
      this.fetchTableData(true);
    }
  }
});
